import { render } from "./PopOverTransition.vue?vue&type=template&id=7cb87556"
const script = {}
script.render = render

export default script